module.exports = __webpack_public_path__ + "img/44.42f49ecb.png";